<template>
  <div class="w-full">
    <t-form
      ref="form"
      class="postal-form-step"
      @submit="onSubmit"
      @submit.prevent
    >
      <h6 class="input-header">Vul hier uw postcode in</h6>

      <div class="postal-form-step__form">
        <PostalSeparateInputs
          :error-messages="errorMessages"
          class="postal-form-step__separate-inputs"
          @change="onChange"
          @result="onResult"
        />

        <FormStepSubmitButton
          id="submitPostal"
          :text="btnText"
          class="postal-form-step__btn"
        />
      </div>
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import PostalSeparateInputs from 'chimera/all/components/form/fields/postal/PostalSeparateInputs.nl'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import FormStepSubmitButton from 'chimera/all/components/form/steps/FormStepSubmitButton'
import { useExperiments } from 'chimera/all/composables/useExperiments'
import { PD_10118_REMOVE_PAINTING_QUESTIONS } from 'chimera/all/constants/experiments'
import DefaultNextStep from '~/pages/offertes-aanvragen/type-opdracht'
import VariantNextStep from '~/pages/offertes-aanvragen/uitvoeringsperiode'

export default {
  name: 'PostalFormStep',

  components: {
    FormErrorMessages,
    FormStepSubmitButton,
    PostalSeparateInputs,
  },

  extends: AbstractFormStep,

  props: {
    btnText: {
      type: String,
      default: 'Ga verder',
    },
  },

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Expose experiment and transition to next step.
     * Exposure happens here (not on mount) so only users who
     * complete the postal step become experiment participants.
     */
    async transition() {
      const { getExperiment, isVariant } = useExperiments(this.$store)
      const experiment = await getExperiment(PD_10118_REMOVE_PAINTING_QUESTIONS)
      this.routeTo(isVariant(experiment, 1) ? VariantNextStep : DefaultNextStep)
    },
  },
}
</script>
